import {
  trackBandView,
  getBandViewStats,
  getMostViewedBands,
} from "./asyncThunks";

export const trackBandViewBuilder = (builder) => {
  builder.addCase(trackBandView.pending, (state) => {
    state.trackView.loading = true;
    state.trackView.error = null;
  });
  builder.addCase(trackBandView.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.trackView.data = data;
    state.trackView.loading = false;
  });
  builder.addCase(trackBandView.rejected, (state, action) => {
    state.trackView.loading = false;
    state.trackView.error = action.error.message;
  });
};

export const getBandViewStatsBuilder = (builder) => {
  builder.addCase(getBandViewStats.pending, (state) => {
    state.viewStats.loading = true;
    state.viewStats.error = null;
  });
  builder.addCase(getBandViewStats.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.viewStats.data = data;
    state.viewStats.loading = false;
  });
  builder.addCase(getBandViewStats.rejected, (state, action) => {
    state.viewStats.loading = false;
    state.viewStats.error = action.error.message;
  });
};

export const getMostViewedBandsBuilder = (builder) => {
  builder.addCase(getMostViewedBands.pending, (state) => {
    state.mostViewed.loading = true;
    state.mostViewed.error = null;
  });
  builder.addCase(getMostViewedBands.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.mostViewed.data = data;
    state.mostViewed.loading = false;
  });
  builder.addCase(getMostViewedBands.rejected, (state, action) => {
    state.mostViewed.loading = false;
    state.mostViewed.error = action.error.message;
  });
};